<template>
<div class="d-flex justify-content-between align-items-center flex-wrap gap-3 py-2 border-top border-light-subtle">

  <!-- Left: Page size selector -->
  <div class="d-none d-sm-flex align-items-center flex-wrap">
    <CustomInput
      type="select"
      v-model="localPageSize"
      :options="formattedOptions"
      label-key="value"
      style="min-width: 80px; max-width: 120px;"
      :nullableVSelecte="false"
      :reduce="item => item.value"
    />
    <span class="ml-2 small text-muted">
      sur {{ totalItems }} élément<span v-if="totalItems > 1">s</span>
    </span>
  </div>

  <!-- Pagination -->
  <div class="flex-grow-1 d-flex justify-content-center justify-content-sm-end">
    <b-pagination
      v-if="localPageSize"
      v-model="localPage"
      :total-rows="totalItems"
      :per-page="localPageSize"
      size="sm"
      @input="onPageChange"
      class="pagination-custom"
    />
  </div>

</div>


</template>

<script>
import CustomInput from "@/components/common/customInput.vue";

export default {
  name: "PaginationControls",
  components: { CustomInput },

  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    totalItems: { type: Number, required: true },
    pageSizeOptions: {
      type: Array,
      default: () => [5, 10, 20, 50]
    }
  },

  data() {
    return {
      localPage: this.page,
      localPageSize: this.pageSize
    };
  },

  computed: {
    formattedOptions() {
      return this.pageSizeOptions.map(size => ({
        id: size,
        value: size
      }));
    }
  },

  watch: {
    page(val) {
      this.localPage = val;
    },
    pageSize(val) {
      this.localPageSize = val;
    },
    localPageSize:function(){
      this.onPageSizeChange()
    }
  },

  methods: {
    onPageChange(newPage) {
      this.$emit('update:page', newPage);
    },
    onPageSizeChange() {
      this.$emit('update:pageSize', this.localPageSize);
    }
  }
};
</script>

<style scoped>

.pagination-custom >>> .page-item {
  margin: 0 2px;
}

.pagination-custom >>> .page-link {
  border-radius: 8px;
  color: #756f60;
  border: 1px solid #dee2e6;
  padding: 0.35rem 0.7rem;
  transition: all 0.2s ease-in-out;
}

.pagination-custom >>> .page-link:hover {
  background-color: #756f60;
  color: #fff;
  border-color: #756f60;
}

.pagination-custom >>> .active .page-link {
  background-color: #756f60;
  border-color: #756f60;
  color: white;
  font-weight: bold;
}

.pagination-custom >>> .disabled .page-link {
  color: #aaa;
  background-color: #f8f9fa;
  border-color: #dee2e6;
}


/* Fancy spacing and responsive tweaks */
@media (max-width: 576px) {
  .b-pagination {
    justify-content: center !important;
    margin-top: 0.5rem;
  }
}
</style>


<style scoped>
.pagination-wrapper {
  display: flex;
  justify-content: center; /* Center by default (small screens) */
}

@media (min-width: 576px) {
  .pagination-wrapper {
    justify-content: flex-start; /* Align left on sm+ screens */
  }
}

/* Optional: make pagination items more spaced/fancy */
.pagination-custom .page-item {
  margin: 0 2px;
}
</style>
